<template>
  <div>
    <a-card title="优惠码">
      <template slot="extra">
        <a-button-group>
          <a-button type="primary" icon="plus" @click="showCommission" v-if="selectedCoupons.length > 0">申请结佣</a-button>
          <a-button icon="reload" @click="getCommissionList">刷新</a-button>
        </a-button-group>
      </template>
      <a-table :row-selection="rowSelection" :columns="columns" :data-source="coupons" :scroll="{x: true}" rowKey="coupon_id">
          <span slot="status" slot-scope="text, record">
            {{ record.status | statusFilter}}
          </span>
          <span slot="trade_status" slot-scope="text, record">
            <template v-if="record.status === 10">
              {{ record.is_paid | tradeStatusFilter }}
            </template>
            <template v-else>
              -
            </template>
          </span>
          <span slot="amount" slot-scope="text, record">
            <template v-if="record.amount > 0">
              {{ record.amount }}
            </template>
            <template v-else>
              -
            </template>
          </span>
          <span slot="commission" slot-scope="text, record">
            <template v-if="record.commission_amount > 0">
              {{ record.commission_amount }}
              <a-tag color="blue" v-if="record.is_commission === 1">待结佣</a-tag>
              <a-tag color="green" v-else-if="record.is_commission === 10">已结佣</a-tag>
            </template>
            <template v-else>
              -
            </template>
          </span>
          <span slot="redeem" slot-scope="text, record">
            <template v-if="record.redeem_time">
              {{ record.redeem_time | timestamp2date }}
              {{ record.redeem_user || '-' }}
            </template>
            <template v-else>
              -
            </template>
          </span>
      </a-table>
    </a-card>
    <a-modal title="申请结佣" v-model="modalCommission" :cancel-text="'取消'" :ok-text="'提交申请'" @ok="applyCommission">
      <a-form :label-col="{ span: 8 }" :wrapper-col="{ span: 9 }">
        <a-form-item label="结佣金额">
          {{ commission.amount }} 元
        </a-form-item>
        <a-form-item label="支付宝账号">
          <a-input v-model="commission.account" style="width: 200px;"></a-input>
        </a-form-item>
        <a-form-item label="再次输入支付宝账号">
          <a-input v-model="checkAccount" style="width: 200px;"></a-input>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { getCommissionList, applyCommission } from '@/api/trade'
import { baseMixin } from '@/libs/app-mixin'
export default {
  name: 'Commission',
  mixins: [baseMixin],
  filters: {
    statusFilter (status) {
      const itemMaps = {
        1: '未使用',
        '-1': '已禁用',
        10: '已使用'
      }
      return itemMaps[status] || '-'
    },
    tradeStatusFilter (status) {
      const itemMaps = {
        1: '已支付',
        0: '未支付'
      }
      return itemMaps[status] || '-'
    }
  },
  data () {
    return {
      modalCommission: false,
      coupons: [],
      columns: [
        {
          title: '优惠码',
          width: 130,
          dataIndex: 'code',
          key: 'code'
        },
        {
          title: '状态',
          width: 100,
          scopedSlots: { customRender: 'status' }
        },
        {
          title: '支付状态',
          width: 100,
          scopedSlots: { customRender: 'trade_status' }
        },
        {
          title: '抵扣金额',
          width: 100,
          scopedSlots: { customRender: 'amount' }
        },
        {
          title: '结佣金额',
          width: 130,
          scopedSlots: { customRender: 'commission' }
        },
        {
          title: '使用状态',
          width: 160,
          scopedSlots: { customRender: 'redeem' }
        }
      ],
      selectedCoupons: [],
      commission: {
        coupon_list: [],
        amount: 0,
        account: ''
      },
      checkAccount: ''
    }
  },
  computed: {
    rowSelection() {
      return {
        onChange: (selectedRowKeys, selectedRows) => {
          // console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows)
          this.selectedCoupons = selectedRows
          this.commission.amount = 0
          this.commission.coupon_list = []
          this.selectedCoupons.forEach(v => {
            this.commission.coupon_list.push(v.coupon_id)
            this.commission.amount += parseFloat(v.commission_amount)
          })
        },
        getCheckboxProps: record => ({
          props: {
            disabled: record.is_enabled === 0,
          },
        }),
      };
    },
  },
  methods: {
    getCommissionList () {
      getCommissionList({}).then(res => {
        this.coupons = res.result
      })
    },
    change () {
      this.getCommissionList()
    },
    showCommission () {
      this.modalCommission = true
    },
    applyCommission () {
      if (this.commission.account.trim().length === 0) {
        this.$message.info('请输入收款支付宝账号')
        return false
      }
      if (this.checkAccount.trim() !== this.commission.account.trim()) {
        this.$message.info('支付宝账号输入不一致')
        return false
      }
      applyCommission({
        commission: this.commission
      }).then(res => {
        if (res.code !== 200) {
          this.$message.info(res.msg)
          return false
        }
        this.modalCommission = false
        this.$message.info('申请完成')
        this.getCommissionList()
      })
    }
  },
  mounted () {
    this.change()
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/My/Commission.vue